import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Routing
import { Route, Routes, Navigate } from 'react-router-dom';

// Redux
import { connect } from 'react-redux';

// Actions
import { toggleSideNav } from './actions/navActions';

// Components
import Navbar from './components/Navbar';
import SidebarMobile from './components/sidebar/SidebarMobile';
import Backdrop from './components/common/Backdrop';

// Pages
import Landing from './pages/Landing';
import Settings from './pages/Settings';
import Authentication from './pages/Authentication';
import Checkout from './pages/Checkout';
import Policies from './pages/Policies';
import Report_Issues from './pages/Report_Issues';

const Pages_With_Navbar = ({
    nav: {
        sideNav
    },
    auth,
    toggleSideNav,
}) => {

    // State for tracking the window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Function to handle window size change
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Check if the device is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1024;

    let backdrop;

    // Create a backdrop component if the sideNav is open
    if (sideNav) {
        backdrop = <Backdrop click={toggleSideNav} />;
    }

    return (
        <Fragment>
            <Navbar />

            {/* Add space to top of page, because Navbar is position:fixed */}
            <div style={{height: '65px'}}></div>

            {/* Main Body */}
            <div className={sideNav ? "app open": "app"}>
                {isMobile && <SidebarMobile slideMenu={sideNav} handleSlideMenu={toggleSideNav} auth={auth} /> }
                {/* Routes => Different Pages */}
                <Routes>
                    <Route exact path="/" element={<Landing />} />
                    <Route exact path="/settings" element={<Navigate to="/settings/account" replace />} />
                    <Route exact path="/settings/account" element={<Settings />} />
                    <Route exact path="/settings/billing" element={<Settings />} />
                    <Route exact path="/signin" element={<Authentication />} />
                    <Route exact path="/signup" element={<Authentication />} />
                    <Route exact path="/checkout" element={<Checkout />} />
                    <Route exact path="/policies" element={<Policies />} />
                    <Route exact path="/report-issues" element={<Report_Issues />} />
                </Routes>

                {backdrop}
            </div>

        </Fragment>
    )
}

Pages_With_Navbar.propTypes = {
    nav: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    toggleSideNav: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    nav: state.nav,
    auth: state.auth
})

export default connect(mapStateToProps, {
    
    // Connecting actions to the component
    toggleSideNav
})(Pages_With_Navbar);